if($('.block-doctors-providers').length) {

    $('.block-doctors-providers').each(function () {

        if(!$(this).find('.team-member-page-1').length) {
            return;
        }

        let parent = $(this),
            totalItems = $(this).find('.team-container').data('total-items'),
            totalPages = $(this).find('.team-container').data('total-pages'),
            paginationPrev = $(this).find('.pagination-prev .page-link'),
            paginationNext = $(this).find('.pagination-next .page-link'),
            paginationItems = $(this).find('.pagination-item .page-link'),
            currentPage = 1;

        function setPage(page) {
            parent.find('.team-member').addClass('d-none');
            parent.find('.team-member-page-' + page).removeClass('d-none');
            currentPage = page;
            parent.find('.pagination-item').removeClass('active');
            parent.find('.pagination-item-' + page).addClass('active');

            // scroll to top of the parent
            $('html, body').animate({
                scrollTop: parent.offset().top - 85
            }, 500);
        }

        paginationPrev.on('click', function (e) {
            e.preventDefault();
            if(currentPage > 1) {
                setPage(currentPage - 1);
            }
        });

        paginationNext.on('click', function (e) {
            console.log(currentPage);
            console.log(totalPages);
            e.preventDefault();
            if(currentPage < totalPages) {
                setPage(currentPage + 1);
            }
        });

        paginationItems.on('click', function (e) {
            e.preventDefault();

            let page = $(this).data('page');
            setPage(page);
        });

    });

}
